import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import { deleteReq, useGet, usePatch, usePost } from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateInventory = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/${activeStore}/coupons/create`);
};

export const useGetInventories = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(`/users/stores/${activeStore}/inventory/all${queryData}`);
  return data;
};

export const useGetInventoryData = (couponId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(couponId ? `/users/${activeStore}/coupons/${couponId}` : null);
};

export const useUpdateInventory = (couponId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(`/users/${activeStore}/coupons/${couponId}`);
};

export const useDeleteInventory = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (couponId: number) => {
      return deleteReq(`/users/${activeStore}/coupons/${couponId}`);
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};

export const useGetInventoryRequests = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  return useGet(`/users/inventory/requests${queryData}`);
};

export const useUpdateInventoryStatus = () => {
  return usePatch(`/users/inventory/request-status`);
};
